// extracted by mini-css-extract-plugin
export var menuIcon = "_o1-0";
export var menuIconInline = "_o1-1";